export function getEventTarget(evt) {
  if (!evt) {
    return undefined;
  }

  return evt.target ? evt.target : evt.srcElement;
}
